"use strict";
module.exports = {
    TsModuleDescriptorUnknown: require("./unknown"),
    TsModuleDescriptorType: require("./type"),
    TsModuleDescriptorName: require("./name"),
    TsModuleDescriptorInfo: require("./info"),
    TsModuleDescriptorModuleLink: require("./module_link"),
    TsModuleDescriptorCrc32: require("./crc32")
};
//# sourceMappingURL=index.js.map